import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { ReactDialogBox } from "react-js-dialog-box";
import generatePDF from "./PDFscore";
import "react-js-dialog-box/dist/index.css";
import "../assets/ohs/admin.css";
import "../assets/ohs/display.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export const WorkermentalHealthawareness = () => {
  const [PdfcardImg, setPdfcardImg] = useState("");
  const [scoreCard, setscoreCard] = useState("");
  const inputRef = useRef(null);
  const Lesson1href_1 = useRef();
  const Lesson1href_2 = useRef();
  const Lesson1href_3 = useRef();
  const lesson2_href = useRef();
  const lesson3_href = useRef();
  const lesson4_href = useRef();
  const lesson5_href = useRef();
  const lesson6_href = useRef();
  const [closeBox, setcloseBox] = useState(true);
  const { id } = useParams();
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  //Lesson1 Start
  const [lesson1, setlesson1] = useState(true);
  const [lesson1step_1, setlesson1step_1] = useState(true);
  const [lesson1step_2, setlesson1step_2] = useState(false);
  const [lesson1step_3, setlesson1step_3] = useState(false);
  const [lesson1step_4, setlesson1step_4] = useState(false);
  const [strokeDashArray_less1, setstrokeDashArray_less1] = useState(false);
  const [istruefalse_1, setistruefalse_1] = useState(false);
  //Lesson1 End

  //Lesson2 Start
  const [lesson2, setlesson2] = useState(false);
  const [strokeDashArray_less2, setstrokeDashArray_less2] = useState(false);
  const [istruefalse_2, setistruefalse_2] = useState(false);
  //Lesson2 End

  //Lesson3 Start
  const [lesson3, setlesson3] = useState(false);
  const [strokeDashArray_less3, setstrokeDashArray_less3] = useState(false);
  const [istruefalse_3, setistruefalse_3] = useState(false);
  //Lesson3 End

  //Lesson4 Start
  const [lesson4, setlesson4] = useState(false);
  const [strokeDashArray_less4, setstrokeDashArray_less4] = useState(false);
  const [istruefalse_4, setistruefalse_4] = useState(false);
  //Lesson4 End

  //Lesson5 Start
  const [lesson5, setlesson5] = useState(false);
  const [strokeDashArray_less5, setstrokeDashArray_less5] = useState(false);
  const [istruefalse_5, setistruefalse_5] = useState(false);
  //Lesson5 End

  //Lesson6 Start
  const [lesson6, setlesson6] = useState(false);
  const [step6_btn, setstep6_btn] = useState(false);
  const [step6_score, setstep6_score] = useState(false);
  const [isOpacity_6_1, setisOpacity_6_1] = useState(false);
  const [checkQ_6_1, setcheckQ_6_1] = useState(false);
  const [worngansQuiz_6_1, setworngansQuiz_6_1] = useState(false);
  const [rightansQuiz_6_1, setrightansQuiz_6_1] = useState(false);
  const [q1_6_next, setq1_6_next] = useState(false);
  const [isfirstquiz_6_1, setisfirstquiz_6_1] = useState(false);
  const [issetQuizAns_6_1_btn, setissetQuizAns_6_1_btn] = useState(false);
  const [quest_6, setquest_6] = useState(true);
  const [score_6, setscore_6] = useState("");
  const [stroke_6, setstroke_6] = useState("#F50057");
  const [finalperc_6, setfinalperc_6] = useState("220");
  const [corr_6, setcorr_6] = useState(true);
  const [strokeDashArray_less6, setstrokeDashArray_less6] = useState(false);
  const [istruefalse_6, setistruefalse_6] = useState(false);
  //Lesson6 End

  //Lesson7 Start
  const [lesson7, setlesson7] = useState(false);
  const [strokeDashArray_less7, setstrokeDashArray_less7] = useState(false);
  const [istruefalse_7, setistruefalse_7] = useState(false);
  //Lesson7 End

  //Lesson8 Start
  const [lesson8, setlesson8] = useState(false);
  const [strokeDashArray_less8, setstrokeDashArray_less8] = useState(false);
  const [istruefalse_8, setistruefalse_8] = useState(false);
  //Lesson8 End

  //Lesson 9 Start
  const [leftmenu_bar, setleftmenu_bar] = useState(0);
  const [barwidth, setbarwidth] = useState(0);
  const [lesson9, setlesson9] = useState(false);
  const [sec_1, setsec_1] = useState(true);
  const [name_9, setname_9] = useState(false);
  const [quizless_9_1, setquizless_9_1] = useState(false);
  const [quizless_9_2, setquizless_9_2] = useState(false);
  const [quizless_9_3, setquizless_9_3] = useState(false);
  const [quizless_9_4, setquizless_9_4] = useState(false);
  const [quizless_9_5, setquizless_9_5] = useState(false);
  const [less_5_finresult, setless_5_finresult] = useState(false);
  const [checkQ_9_1, setcheckQ_9_1] = useState("");
  const [isfirstquiz_9_1, setisfirstquiz_9_1] = useState(false);
  const [issetQuizAns_9_1_btn, setissetQuizAns_9_1_btn] = useState(false);
  const [isOpacity_9, setisOpacity_9] = useState(false);

  const [worngansQuiz_9_1, setworngansQuiz_9_1] = useState(false);
  const [rightansQuiz_9_1, setrightansQuiz_9_1] = useState(false);
  const [q1_9_next, setq1_9_next] = useState(false);
  const [checkbtn_quiz_1_9, setcheckbtn_quiz_1_9] = useState(false);

  const [isOpacity_9_1, setisOpacity_9_1] = useState(false);
  const [checkQ_9_2, setcheckQ_9_2] = useState(false);
  const [isfirstquiz_9_2, setisfirstquiz_9_2] = useState(false);
  const [issetQuizAns_9_2_btn, setissetQuizAns_9_2_btn] = useState(false);

  const [checkbtn_quiz_2_9, setcheckbtn_quiz_2_9] = useState(false);
  const [q2_9_next, setq2_9_next] = useState(false);

  const [checkQ_9_3, setcheckQ_9_3] = useState(false);
  const [isfirstquiz_9_3, setisfirstquiz_9_3] = useState(false);
  const [issetQuizAns_9_3_btn, setissetQuizAns_9_3_btn] = useState(false);

  const [checkbtn_quiz_3_9, setcheckbtn_quiz_3_9] = useState(false);
  const [q3_9_next, setq3_9_next] = useState(false);

  const [checkQ_9_4, setcheckQ_9_4] = useState(false);
  const [isfirstquiz_9_4, setisfirstquiz_9_4] = useState(false);
  const [issetQuizAns_9_4_btn, setissetQuizAns_9_4_btn] = useState(false);

  const [checkbtn_quiz_4_9, setcheckbtn_quiz_4_9] = useState(false);
  const [q4_9_next, setq4_9_next] = useState(false);

  const [checkQ_9_5, setcheckQ_9_5] = useState(false);
  const [isfirstquiz_9_5, setisfirstquiz_9_5] = useState(false);
  const [issetQuizAns_9_5_btn, setissetQuizAns_9_5_btn] = useState(false);

  const [checkbtn_quiz_5_9, setcheckbtn_quiz_5_9] = useState(false);
  const [q5_9_next, setq5_9_next] = useState(false);
  const [score__per5, setscore__per5] = useState([]);
  const [score_5, setscore_5] = useState([]);
  const [corrScore, setcorrScore] = useState(false);
  const [strokeDashArray_less9, setStrokeDashArray_less9] = useState("");
  const [istruefalse_9, setistruefalse_9] = useState(false);
  //Lesson 9 End
  useEffect(() => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    if (userStr === null) {
      window.location.href = "/login";
    }
    changeFavicon(require("../assets/admin/images/f-icon.png"));

    document.title = "Start Course";

    let formdata = {
      code: id,
    };
    if (scoreCard != "") {
      pdfdataget();
      setscoreCard("");
    }
  }, [id, scoreCard, PdfcardImg]);
  function formatDate_notes() {
    const options = {
      day: "2-digit",
      month: "long", // Change to "long" for full month name
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Australia/Perth",
    };

    const date = new Date();
    return date.toLocaleDateString("en-GB", options);
  }
  //Pdf
  function getimagedata(urll) {
    let formdata = {
      url: urll,
    };
    const imgBase64 =
      "data:image/png;base64,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";
    const mainpdf = (
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <link rel="icon" href="/" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#000000" />
          <meta
            name="description"
            content="Web site created using create-react-app"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Quattrocento:wght@400;700&display=swap"
            rel="stylesheet"
          />
        </head>
        <body>
          <table
            style={{
              width: "700px",
              margin: "0 auto",
              border: "10px solid rgb(0, 74, 173)",
            }}
          >
            <tbody style={{ width: "100%" }}>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h1
                    style={{
                      color: "rgb(0, 74, 173)",
                      fontSize: "35px",
                      textAlign: "center",
                      padding: "0px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Certificate of Training
                  </h1>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    This is to certify that
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#323232",
                        fontWeight: 400,
                        marginTop: "30px",
                        fontSize: "20px",
                        textAlign: "center",
                        padding: "5px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {name_9}
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      marginTop: "30px",
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    has successfully completed training in
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "12px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      Workplace Mental Health Awareness
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style={{
                      padding: "10px 0px",
                      marginTop: "15px",
                    }}
                  >
                    <h5
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      undertaken on the date
                    </h5>
                    <h6
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {formatDate_notes()}
                    </h6>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      paddingTop: "40px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Delivered by:
                  </h2>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                      paddingBottom: "10px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    );
    const filenamee = "Workplace Mental Health Awareness";

    setTimeout(() => {
      generatePDF(mainpdf, filenamee);
    }, 500);
  }
  const pdfdataget = async () => {
    const cc = await getimagedata("logo1.png");
  };
  const downloadpdf = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    let formdata = {
      user_id: userStr[0].id,
      id: id,
      name: name_9,
    };
    console.log(formdata);
    //setscoreCard(1);

    axios
      .post("https://jlmining.app/coursepdf", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => { })
      .catch((err) => { });
    pdfdataget();
  };
  //Pdf
  //Lesson1 Start
  const Lesson_1nextsection = (event) => {
    if (event === "1") {
      setstrokeDashArray_less1(250.36);
      setlesson1step_1(false);
      setlesson1step_2(true);
      setTimeout(() => {
        Lesson1href_1.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "2") {
      setstrokeDashArray_less1(350.36);
      setlesson1step_2(false);
      setlesson1step_3(true);
      setTimeout(() => {
        Lesson1href_2.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "3") {
      setstrokeDashArray_less1(458.36);
      setlesson1step_3(false);
      setlesson1step_4(true);
      setTimeout(() => {
        Lesson1href_3.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };
  //Lesson1 End

  const Lesson_next = (event) => {
    if (event === "1") {
      setistruefalse_1(true);
      setlesson1(false);
      setlesson2(true);
      setTimeout(() => {
        lesson2_href.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
      setleftmenu_bar(9.5);
      setbarwidth(9.5);
    }
    if (event === "2") {
      setstrokeDashArray_less2(458.36);
      setistruefalse_2(true);
      setlesson2(false);
      setlesson3(true);
      setTimeout(() => {
        lesson3_href.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
      setleftmenu_bar(19);
      setbarwidth(19);
    }
    if (event === "3") {
      setstrokeDashArray_less3(458.36);
      setistruefalse_3(true);
      setlesson3(false);
      setlesson4(true);
      setTimeout(() => {
        lesson4_href.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
      setleftmenu_bar(28.5);
      setbarwidth(28.5);
    }
    if (event === "4") {
      setstrokeDashArray_less4(458.36);
      setistruefalse_4(true);
      setlesson4(false);
      setlesson5(true);
      setTimeout(() => {
        lesson5_href.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
      setleftmenu_bar(49);
      setbarwidth(49);
    }
    if (event === "5") {
      setstrokeDashArray_less5(458.36);
      setistruefalse_5(true);
      setlesson5(false);
      setlesson6(true);
      setTimeout(() => {
        lesson6_href.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
      setleftmenu_bar(68);
      setbarwidth(68);
    }
    if (event === "6") {
      setlesson6(false);
      setlesson7(true);
      setleftmenu_bar(87);
      setbarwidth(87);
    }
    if (event === "7") {
      setlesson7(false);
      setlesson8(true);
      setstrokeDashArray_less7(458.36);
      setistruefalse_7(true);
      setleftmenu_bar(90);
      setbarwidth(90);
    }
    if (event === "8") {
      setlesson8(false);
      setlesson9(true);
      setstrokeDashArray_less8(458.36);
      setistruefalse_8(true);
      setleftmenu_bar(95);
      setbarwidth(95);
    }
  };

  //Lesson6
  const startQuiz_6_1 = (event) => {
    setcheckQ_6_1(event);
    setstep6_btn(true);
  };
  const check6_btn = () => {
    setstep6_btn(false);
    setisOpacity_6_1(true);
    if (checkQ_6_1 === "Everyone") {
      setcorr_6(false);
      setrightansQuiz_6_1(true);
      setworngansQuiz_6_1(false);
      setscore_6("100");
      setfinalperc_6("345");
    } else {
      setcorr_6(true);
      setrightansQuiz_6_1(false);
      setworngansQuiz_6_1(true);
      setscore_6("0");
      setstroke_6("");
      setfinalperc_6("220");
    }
    setisfirstquiz_6_1(true);
    setissetQuizAns_6_1_btn("Everyone");
    setq1_6_next(true);
    setcheckQ_6_1("");
  };
  const Quiz_next_6 = (event) => {
    setquest_6(false);
    setstep6_score(true);
    setstrokeDashArray_less6(458.36);
    setistruefalse_6(true);
  };
  const refresh_6 = () => {
    setlesson6(false);
    setstep6_btn(false);
    setstep6_score(false);
    setisOpacity_6_1(false);
    setcheckQ_6_1(false);
    setworngansQuiz_6_1(false);
    setrightansQuiz_6_1(false);
    setq1_6_next(false);
    setisfirstquiz_6_1(false);
    setissetQuizAns_6_1_btn(false);
    setquest_6(true);
    setscore_6("");
    setstroke_6("#F50057");
    setfinalperc_6("220");
  };

  //Lesson6
  //Lesson9
  const entername_9 = (event) => {
    const trimmedValue = event.target.value.trim();
    if (trimmedValue === "") {
      setname_9(false);
    } else {
      setname_9(trimmedValue);
    }
  };
  const btn_entername = () => {
    if (name_9 !== false) {
      setquizless_9_1(true);
      setsec_1(false);
    }
  };
  const startQuiz_9_1 = (event) => {
    setcheckQ_9_1(event);
    setcheckbtn_quiz_1_9(true);
  };

  const startQuiz_9_2 = (event) => {
    setcheckQ_9_2(event);
    setcheckbtn_quiz_2_9(true);
    setissetQuizAns_9_2_btn(event);
  };
  const startQuiz_9_3 = (event) => {
    setcheckQ_9_3(event);
    setcheckbtn_quiz_3_9(true);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
  };
  const startQuiz_9_4 = (event) => {
    setcheckQ_9_4(event);
    setcheckbtn_quiz_4_9(true);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
  };
  const startQuiz_9_5 = (event) => {
    setcheckQ_9_5(event);
    setcheckbtn_quiz_5_9(true);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
    setissetQuizAns_9_5_btn(event);
  };
  const Quiz_check_9 = (event) => {
    if (event === "1") {
      setisOpacity_9(true);
      if (checkQ_9_1 === "False") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_1_btn("False");
      setisfirstquiz_9_1(true);
      setq1_9_next(true);
      setcheckbtn_quiz_1_9(false);
      setcheckQ_9_1("");
      setStrokeDashArray_less9(200.39);
    }
    if (event === "2") {
      setisOpacity_9(true);
      if (checkQ_9_2 === "Complete") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }

      setisfirstquiz_9_2(true);
      setq2_9_next(true);
      setcheckbtn_quiz_2_9(false);
      setcheckQ_9_2("");
      setStrokeDashArray_less9(300.39);
    }
    if (event === "3") {
      setisOpacity_9(true);
      if (checkQ_9_3 === "All of") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_3_btn("All of");
      setisfirstquiz_9_3(true);
      setq3_9_next(true);
      setcheckbtn_quiz_3_9(false);
      setcheckQ_9_3("");
      setStrokeDashArray_less9(350.39);
    }
    if (event === "4") {
      setisOpacity_9(true);
      if (checkQ_9_4 === "True") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_4_btn("True");
      setisfirstquiz_9_4(true);
      setq4_9_next(true);
      setcheckbtn_quiz_4_9(false);
      setcheckQ_9_4("");
      setStrokeDashArray_less9(400.39);
    }
    if (event === "5") {
      setisOpacity_9(true);
      if (checkQ_9_5 === "Workers") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }

      setisfirstquiz_9_5(true);
      setq5_9_next(true);
      setcheckbtn_quiz_5_9(false);
      setcheckQ_9_5("");

      setistruefalse_9(true);
      setStrokeDashArray_less9(458.39);
    }
  };
  const Quiz_next_9 = (event) => {
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
    if (event === "1") {
      setquizless_9_2(true);
      setquizless_9_1(false);
      setcheckbtn_quiz_1_9(false);
    }
    if (event === "2") {
      setquizless_9_3(true);
      setquizless_9_2(false);
      setrightansQuiz_9_1(false);
      setcheckbtn_quiz_2_9(false);
    }
    if (event === "3") {
      setquizless_9_4(true);
      setquizless_9_3(false);
      setcheckbtn_quiz_3_9(false);
    }
    if (event === "4") {
      setquizless_9_5(true);
      setquizless_9_4(false);
      setcheckbtn_quiz_4_9(false);
    }
    if (event === "5") {
      setquizless_9_5(false);
      setless_5_finresult(true);
      setleftmenu_bar(100);
      setbarwidth(100);
      setleftmenu_bar(100);
      setbarwidth(100);
      const sum = score_5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const sum_per = score__per5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      setscore_5(sum);
      setscore__per5(sum_per);
      if (sum_per >= 80) {
        setcorrScore(true);
      }
    }
  };
  const refreshbtn = (event) => {
    console.log("ss");
    setless_5_finresult(false);
    setsec_1(true);
    setname_9(false);
    setquizless_9_1(false);
    setquizless_9_2(false);
    setquizless_9_3(false);
    setquizless_9_4(false);
    setquizless_9_5(false);

    setcheckQ_9_1("");
    setisfirstquiz_9_1(false);
    setissetQuizAns_9_1_btn(false);
    setisOpacity_9(false);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
    setq1_9_next(false);
    setcheckbtn_quiz_1_9(false);
    setisOpacity_9_1(false);
    setcheckQ_9_2(false);
    setisfirstquiz_9_2(false);
    setissetQuizAns_9_2_btn(false);
    setcheckbtn_quiz_2_9(false);
    setq2_9_next(false);
    setcheckQ_9_3(false);
    setisfirstquiz_9_3(false);
    setissetQuizAns_9_3_btn(false);
    setcheckbtn_quiz_3_9(false);
    setq3_9_next(false);
    setcheckQ_9_4(false);
    setisfirstquiz_9_4(false);
    setissetQuizAns_9_4_btn(false);
    setcheckbtn_quiz_4_9(false);
    setq4_9_next(false);
    setcheckQ_9_5(false);
    setisfirstquiz_9_5(false);
    setissetQuizAns_9_5_btn(false);
    setcheckbtn_quiz_5_9(false);
    setq5_9_next(false);
    setscore__per5([]);
    setscore_5([]);
    setcorrScore(false);
    setStrokeDashArray_less9("");
    setistruefalse_9(false);
  };
  //Lesson9
  //Lesson back
  const backlesson = (event) => {
    if (event === "1") {
      setlesson1(true);
      setlesson2(false);
    }
    if (event === "2") {
      setlesson2(true);
      setlesson3(false);
    }
    if (event === "6") {
      setlesson6(true);
      setlesson7(false);
    }
  };
  const menubars = () => {
    setcloseBox(!closeBox);
  };
  return (
    <>
      <div
        className={`d-flex main-admin-block align-items-stretch mt-4 ${closeBox ? "" : "close-box"
          }`}
      >
        <div className="flex-shrink-0 side-layer">
          <div className="scroll-height">
            <div className="d-flex flex-column">
              <div className="top-title d-flex flex-column gap-5">
                <h1>Workplace Mental Health Awareness</h1>
                <div className="d-flex flex-column gap-1">
                  <div className="progress-bar-full">
                    <div style={{ width: `${barwidth}%` }}></div>
                  </div>
                  <h4 className="pro-number">
                    <span>{leftmenu_bar}%</span> COMPLETE
                  </h4>
                </div>
              </div>

              <div className="d-flex flex-column side-navbar mt-4">
                <Link
                  to="workplace.html"
                  className="d-flex align-items-center gap-3 list-link anilink active"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Introduction</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_1 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_1 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less1 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Recognizing Psychosocial Hazards</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_2 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_2 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less2 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Evaluating the Risks Linked to Psychosocial Hazards</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_3 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_3 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less3 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Managing the Hazards</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_4 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_4 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less4 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Monitoring and Evaluating Control Measures</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_5 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_5 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less5 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Quiz</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_6 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_6 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less6 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>
                      Addressing a Report of a Psychosocial Risk or Incident
                    </h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_7 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_7 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less7 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Supporting Recovery</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_8 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_8 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less8 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Final Assessment</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_9 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_9 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less9 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 rightpart">
          {lesson1 && (
            <section id="introd" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to={`/start-course/${id}`}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Home</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 1 of 9</h4>
                      <h1>Introduction</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    {lesson1step_1 && (
                      <div
                        id="legal"
                        className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                      >
                        <p>
                          The Organization, as a Person Conducting a Business or
                          Undertaking (PCBU), holds the responsibility to
                          ensure, to the extent reasonably practicable, the
                          health, safety, and well-being of workers, as well as
                          to prevent risks to others in the workplace.
                        </p>
                        <p>
                          According to health and safety legislation, 'health'
                          encompasses both physical and psychological
                          well-being. This implies that the obligation to
                          address psychosocial hazards and risks is equivalent
                          to addressing physical hazards and risks.
                          Consequently, it is incumbent upon us to effectively
                          manage psychosocial hazards in the workplace to
                          mitigate the risk of both work-related psychological
                          and physical injuries and incidents.
                        </p>
                        <p>
                          Various hazards in the workplace can impact the mental
                          health of workers, including:
                        </p>
                        <ul className="d-flex flex-column gap-3">
                          <li>
                            <p>The physical environment of the workplace.</p>
                          </li>
                          <li>
                            <p>
                              The nature and complexity of the work concerning
                              workers' knowledge and training.
                            </p>
                          </li>
                          <li>
                            <p>
                              Poorly managed work procedures, changes, and
                              demands leading to job insecurity.
                            </p>
                          </li>
                          <li>
                            <p>Excessive or prolonged work pressures.</p>
                          </li>
                          <li>
                            <p>Fatigue.</p>
                          </li>
                          <li>
                            <p>
                              Bullying and/or harassment (including sexual
                              harassment).
                            </p>
                          </li>
                          <li>
                            <p>Exposure to violent or traumatic events.</p>
                          </li>
                          <li>
                            <p>
                              Implementation of work restrictions beyond the
                              Organization's control.
                            </p>
                          </li>
                          <li>
                            <p>
                              Conflicting work demands, changes, and lack of
                              role clarity.
                            </p>
                          </li>
                          <li>
                            <p>
                              Ineffective communication and limited involvement
                              in decision-making processes affecting workers.
                            </p>
                          </li>
                        </ul>
                      </div>
                    )}
                    {lesson1step_1 && (
                      <div className="d-block padding btn-block text-center">
                        <button
                          type="button"
                          onClick={() => Lesson_1nextsection("1")}
                        >
                          CONTINUE
                        </button>
                      </div>
                    )}
                    {lesson1step_2 && (
                      <div
                        id="legal"
                        className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                      >
                        <div
                          className="d-flex flex-column gap-3 py-3"
                          ref={Lesson1href_1}
                        >
                          <h5>What Constitutes a Psychosocial Hazard?</h5>
                          <p>
                            A psychosocial hazard refers to a hazard stemming
                            from or associated with elements of work and
                            circumstances that might induce a stress reaction in
                            workers.
                          </p>
                          <p>
                            Work-related stress encompasses the physical,
                            mental, and emotional responses that occur when
                            workers feel that the demands of their work surpass
                            their capacity to manage. Nonetheless, if
                            work-related stress becomes overwhelming or
                            persists, it can result in psychological harm,
                            irrespective of whether it also causes physical
                            harm.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  {lesson1step_2 && (
                    <div className="d-block px-5">
                      <img
                        className="w-100 px-5"
                        src={require("../assets/ohs/images/workplace.png")}
                        alt="img"
                      />
                      <div className="d-block padding btn-block text-center">
                        <button
                          type="button"
                          onClick={() => Lesson_1nextsection("2")}
                        >
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="col-lg-10 offset-md-1">
                    {lesson1step_3 && (
                      <div
                        ref={Lesson1href_2}
                        id="legal"
                        className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                      >
                        <h5>Mental Health Statistics</h5>
                        <p>
                          As per Safe Work Australia's data from 2021, an
                          average of 7,984 Australians receive compensation
                          annually for work-related mental health conditions.
                          This translates to roughly 9% of all serious workers'
                          compensation claims being attributed to work-related
                          mental health issues.
                        </p>
                      </div>
                    )}
                    {lesson1step_3 && (
                      <div className="d-block padding btn-block text-center">
                        <button
                          type="button"
                          onClick={() => Lesson_1nextsection("3")}
                        >
                          CONTINUE
                        </button>
                      </div>
                    )}
                    {lesson1step_4 && (
                      <div
                        id="legal"
                        ref={Lesson1href_3}
                        className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                      >
                        <h5>
                          What The Organisation Will Do To Meet Their Health And
                          Safety Responsibility?
                        </h5>
                        <div className="d-block">
                          <img
                            className="w-100"
                            src={require("../assets/ohs/images/treate.png")}
                            alt="image"
                          />
                        </div>
                        <p>
                          In collaboration with our employees, we are committed
                          to fostering mental well-being through a three-phase
                          strategy:
                        </p>
                        <div className="human d-flex flex-column gap-3 py-3">
                          <div className="d-flex align-items-start gap-3 gap-md-5">
                            <div className="no1">
                              <p>1</p>
                            </div>
                            <p>
                              Promoting Positive Mental Health: We prioritize
                              maintaining a positive mental health environment
                              by identifying, assessing, controlling, and
                              reviewing job, task, and role hazards and risks.
                              This involves implementing written procedures,
                              offering information, instruction, and training to
                              our workforce.
                            </p>
                          </div>
                          <div className="d-flex align-items-start gap-3 gap-md-5">
                            <div className="no1">
                              <p>2</p>
                            </div>
                            <p>
                              Early Intervention: We conduct continuous reviews
                              of existing control measures and provide support
                              to workers who may be at risk.
                            </p>
                          </div>
                          <div className="d-flex align-items-start gap-3 gap-md-5">
                            <div className="no1">
                              <p>3</p>
                            </div>
                            <p>
                              Supporting Recovery: We are dedicated to assisting
                              injured workers in their recovery process.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    {lesson1step_4 && (
                      <div className="d-block padding btn-block text-center">
                        <button type="button" onClick={() => Lesson_next("1")}>
                          CONTINUE
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson2 && (
            <section id="psychosocial" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#introd"
                  onClick={() => backlesson("1")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 1-Introduction</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row" ref={lesson2_href}>
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 2 of 9</h4>
                      <h1>Recognizing Psychosocial Hazards</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>Types of Workplace Hazards Impacting Mental Health:</p>

                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>Environmental Hazards</p>
                        </li>
                        <li>
                          <p>Organizational Hazards</p>
                        </li>
                        <li>
                          <p>Individual Hazards</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="d-block px-5">
                    <img
                      className="w-100 px-5"
                      src={require("../assets/ohs/images/psy.jpg")}
                      alt="img"
                    />
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>Examples of these hazards are outlined below:</p>
                      <div className="d-width">
                        <div className="width">
                          <div className="row">
                            <div className="col-4 p-0">
                              <div className="environmental h-100">
                                <h3>Environmental Hazards</h3>
                                <ul className="d-flex flex-column justify-content-center py-5 gap-3 h-100">
                                  <li>
                                    <p>Long-term exposure to loud noise.</p>
                                  </li>
                                  <li>
                                    <p>Extreme temperatures.</p>
                                  </li>
                                  <li>
                                    <p>Low air quality.</p>
                                  </li>
                                  <li>
                                    <p>Hazardous equipment.</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-4 p-0">
                              <div className="environmental h-100">
                                <h3>Organisational Hazards</h3>
                                <ul className="d-flex flex-column gap-3 justify-content-center py-5 h-100">
                                  <li>
                                    <p>Extended working hours.</p>
                                  </li>
                                  <li>
                                    <p>Fatigue due to shift work.</p>
                                  </li>
                                  <li>
                                    <p>Overwhelming workloads.</p>
                                  </li>
                                  <li>
                                    <p>Emotionally taxing tasks.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Encounters with violence, aggression, or
                                      traumatic content.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Monotonous or repetitive tasks.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Isolated work without adequate support.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Lack of clarity in roles.</p>
                                  </li>
                                  <li>
                                    <p>Unaddressed organizational changes.</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-4 p-0">
                              <div className="environmental h-100">
                                <h3>Individual Hazards</h3>
                                <ul className="d-flex flex-column gap-3 justify-content-center h-100 py-5">
                                  <li>
                                    <p>
                                      Workers lacking adequate training,
                                      information, or instructions to safely and
                                      effectively perform their tasks. Tensions
                                      or disputes between management and
                                      workers, among colleagues, or between
                                      workers and clients/customers, including
                                      instances of bullying, aggression,
                                      harassment (including sexual harassment),
                                      discrimination, or other forms of
                                      unreasonable conduct.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p>
                        Hence, psychosocial hazards and risks can be discerned
                        through:
                      </p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            Engaging in dialogue and consultations with our
                            workers to understand work-related activities and
                            address underlying issues or apprehensions.
                          </p>
                        </li>
                        <li>
                          <p>
                            Conducting inspections of the workplace environment.
                          </p>
                        </li>
                        <li>
                          <p>
                            Observing interactions and noting shifts in staff
                            behaviors within the workplace.
                          </p>
                        </li>
                        <li>
                          <p>
                            Reviewing reports and records for any indications of
                            potential hazards.
                          </p>
                        </li>
                        <li>
                          <p>
                            Employing a confidential survey tool to collect
                            insights from staff members.
                          </p>
                        </li>
                        <li>
                          <p>
                            Ensuring that feedback from isolated workers, such
                            as those working remotely, is actively considered.
                          </p>
                        </li>
                        <li>
                          <p>
                            Assessing the distribution of tasks across the
                            organization.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => Lesson_next("2")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson3 && (
            <section id="evaluating" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={lesson3_href}
                  to="#psychosocial"
                  onClick={() => backlesson("2")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 2-Recognizing Psychosocial Hazards</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 3 of 9</h4>
                      <h1>
                        Evaluating the Risks Linked to Psychosocial Hazards
                      </h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        Reflect on the potential consequences if workers
                        encounter the identified hazards and risks within the
                        workplace. While many hazards and their associated risks
                        are commonly recognized, some may necessitate formal
                        assessment procedures for identification.
                      </p>
                      <p>
                        Hence, we will evaluate the risk to your mental
                        well-being by thoroughly scrutinizing the identified
                        risk factors to ascertain the degree of risk and aid in
                        prioritizing the implementation of control measures.
                      </p>
                      <p>
                        When deliberating on controls, we will consider the
                        following:
                      </p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            The nature of the incident and the hazard's
                            potential to cause harm.
                          </p>
                        </li>
                        <li>
                          <p>
                            The duration, frequency, and intensity of exposure
                            to psychosocial hazards for workers and others.
                          </p>
                        </li>
                        <li>
                          <p>Variances in individual characteristics.</p>
                        </li>
                        <li>
                          <p>Workers' physical and mental fitness.</p>
                        </li>
                        <li>
                          <p>
                            Potential interactions or combinations of
                            psychosocial hazards.
                          </p>
                        </li>
                        <li>
                          <p>
                            Work design, encompassing job demands and tasks.
                          </p>
                        </li>
                        <li>
                          <p>
                            Work systems, including management, organization,
                            and support.
                          </p>
                        </li>
                        <li>
                          <p>
                            Workplace design, layout, and environmental
                            conditions, including safe entry and exit routes and
                            welfare facilities.
                          </p>
                        </li>
                        <li>
                          <p>
                            Design, layout, and environmental factors specific
                            to workers' workspaces.
                          </p>
                        </li>
                        <li>
                          <p>
                            Machinery, substances, and structures within the
                            workplace. Interpersonal dynamics and behaviors.
                          </p>
                        </li>
                        <li>
                          <p>
                            Management and communication of organizational or
                            structural changes.
                          </p>
                        </li>
                        <li>
                          <p>
                            Provision of information, training, instruction, and
                            supervision to workers.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => Lesson_next("3")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson4 && (
            <section id="hazards" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#evaluating"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>
                    Lesson 3-Evaluating the Risks Linked to Psychosocial Hazards
                  </h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row" ref={lesson4_href}>
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 4 of 9</h4>
                      <h1>Managing the Hazards</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        The Organization will enact control measures to mitigate
                        your risks and exposure to psychosocial injuries,
                        striving to eliminate such risks wherever reasonably
                        possible. In cases where complete elimination isn't
                        feasible, we will endeavor to minimize the risk by
                        modifying:
                      </p>

                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>Work management practices.</p>
                        </li>
                        <li>
                          <p>Workplace equipment, materials, and structures.</p>
                        </li>
                        <li>
                          <p>
                            Work systems, encompassing management, organization,
                            and support.
                          </p>
                        </li>
                        <li>
                          <p>Job demands and task arrangements.</p>
                        </li>
                        <li>
                          <p>Environmental conditions within the workplace.</p>
                        </li>
                        <li>
                          <p>
                            Information, training, instruction, and supervision
                            provided to workers.
                          </p>
                        </li>
                      </ul>
                      <p>
                        The hierarchy of control measures will be applied where
                        practicable to manage psychosocial hazards and risks, or
                        as mandated by law.
                      </p>
                      <div className="d-block">
                        <img
                          className="w-100"
                          src={require("../assets/ohs/images/create.png")}
                          alt="img"
                        />
                      </div>
                      <p>
                        Relying solely on information, instruction, or training
                        to mitigate risks will not sufficiently safeguard
                        workers from psychological harm. Hence, the Organization
                        will ensure that these measures are complemented with
                        other controls.
                      </p>
                      <p>
                        A comprehensive prevention plan must be established,
                        implemented, and enforced for identified psychosocial
                        hazards in the workplace, especially concerning:
                      </p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>Aggression or violence.</p>
                        </li>
                        <li>
                          <p>Bullying.</p>
                        </li>
                        <li>
                          <p>Exposure to traumatic content or events.</p>
                        </li>
                        <li>
                          <p>High job demands.</p>
                        </li>
                        <li>
                          <p>Sexual harassment.</p>
                        </li>
                      </ul>
                      <h5>
                        Common Strategies for Managing Work-Related Psychosocial
                        Hazards and Risks Across Industries
                      </h5>
                      <div className="d-width">
                        <div className="width ">
                          <div className="row ps-4 ps-md-0">
                            <div className="col-2 p-0">
                              <div className="environmental h-100">
                                <h3>Industry</h3>
                                <strong className="d-flex align-items-center flex-column justify-content-center py-5 gap-3 h-100">
                                  Health care
                                </strong>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <h3>Example Psychosocial Hazard</h3>
                                <ul className="d-flex flex-column gap-3 justify-content-center py-5 h-100">
                                  <li>
                                    <p>Role overload</p>
                                  </li>
                                  <li>
                                    <p>
                                      Exposure to traumatic content or events
                                    </p>
                                  </li>
                                  <li>
                                    <p>Workplace violence and aggression</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <h3>Example Control Measures</h3>
                                <ul className="d-flex flex-column gap-3 justify-content-center h-100 py-5">
                                  <li>
                                    <p>
                                      Rostering sufficient worker numbers to
                                      effectively manage the workload without
                                      increasing the risk of a psychological
                                      injury.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      The provision of sufficient experienced
                                      supervision to ensure effective management
                                      of traumatic events and the provision of
                                      opportunities to consult (for eg safety
                                      debriefing, early referral to support
                                      services), as well as a peer support
                                      program for workers.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Ensuring workers are adequately trained to
                                      respond effectively to violent incidents
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Training in Violence Prevention and
                                      Management and hazard/incident reporting,
                                      including an escalation process to
                                      management.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Provision of effective, professional post
                                      incident support to reduce the potential
                                      impact of the incident.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="row ps-4  ps-md-0">
                            <div className="col-2 p-0">
                              <div className="environmental h-100">
                                <strong className="br-top d-flex align-items-center flex-column justify-content-center py-5 gap-3 h-100">
                                  School
                                </strong>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center py-5 h-100">
                                  <li>
                                    <p>Role overload.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Poor organisational change consultation.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Poor support.</p>
                                  </li>
                                  <li>
                                    <p>Low job control.</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center h-100 py-5">
                                  <li>
                                    <p>Consultation with workers.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Review current tasks and new demands to
                                      effectively prioritise work.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Monitor and review the work hours.</p>
                                  </li>
                                  <li>
                                    <p>Employ more permanent teachers.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Provide system support centrally available
                                      for schools to access.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Ensure that there are enough resources
                                      allocated.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Undertake analysis to inform the
                                      re-prioritisation of tasks and communicate
                                      to affected workers.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Provide support and required professional
                                      learning to undertake additional tasks
                                      within core working hours.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="row ps-4  ps-md-0">
                            <div className="col-2 p-0">
                              <div className="environmental h-100">
                                <strong className="br-top d-flex align-items-center flex-column justify-content-center py-5 gap-3 h-100">
                                  Construction
                                </strong>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center py-5 h-100">
                                  <li>
                                    <p>
                                      Poor emotional and practical supervisor
                                      and manager support.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Workplace violence and aggression.</p>
                                  </li>
                                  <li>
                                    <p>Poor workplace relationships.</p>
                                  </li>
                                  <li>
                                    <p>Low job control.</p>
                                  </li>
                                  <li>
                                    <p>Role overload demands.</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center h-100 py-5">
                                  <li>
                                    <p>
                                      Develop behaviour standards for all their
                                      workers.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Informs workers that aggressive behaviour
                                      can be reported to him directly
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Undertake regular ‘welfare checks’ and
                                      consult with the worker to check on their
                                      wellbeing and provide information about
                                      psychological support services if
                                      necessary.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Review the supervision and support of
                                      workers.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Commence daily toolbox talks with all
                                      workers to provide relevant information
                                      and instructions.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Set time aside each week to understand
                                      work requirements, assess progress,
                                      develop learning goals and arrange support
                                      required.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="row ps-4  ps-md-0">
                            <div className="col-2 p-0">
                              <div className="environmental h-100">
                                <strong className="br-top d-flex align-items-center flex-column justify-content-center py-5 gap-3 h-100">
                                  Call centre
                                </strong>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center py-5 h-100">
                                  <li>
                                    <p>Role overload.</p>
                                  </li>
                                  <li>
                                    <p>Emotionally demanding work.</p>
                                  </li>
                                  <li>
                                    <p>Role conflict.</p>
                                  </li>
                                  <li>
                                    <p>Low job control.</p>
                                  </li>
                                  <li>
                                    <p>Lack of task variety.</p>
                                  </li>
                                  <li>
                                    <p>Lack of role clarity.</p>
                                  </li>
                                  <li>
                                    <p>Poor change management.</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center h-100 py-5">
                                  <li>
                                    <p>
                                      In consultation, renegotiate service level
                                      agreements and response times so they are
                                      manageable with existing worker numbers.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Improve scripting.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Install more comfortable furniture in
                                      waiting areas.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Triage complex issues to more experienced
                                      workers first.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Provide task rotation so workers can build
                                      new skills and get a break from stressful
                                      calls/interactions.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Ensure workers take short breaks, away
                                      from their workstation.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Provide emotional support during and
                                      following abusive interactions (eg ability
                                      to escalate the issue to a supervisor,
                                      debrief time and to recover away from the
                                      general work area if required).
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Develop call monitoring policies in
                                      consultation with workers and uses these
                                      for coaching.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Ensure the workplace layout, design and
                                      ergonomics are specifically designed to
                                      handle a high volume of calls with minimum
                                      interference between call centre workers.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Provide training.</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="row ps-4  ps-md-0">
                            <div className="col-2 p-0">
                              <div className="environmental h-100">
                                <strong className="br-top d-flex align-items-center flex-column justify-content-center py-5 gap-3 h-100">
                                  Retail store
                                </strong>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center py-5 h-100">
                                  <li>
                                    <p>Role overload.</p>
                                  </li>
                                  <li>
                                    <p>Hazardous working environment.</p>
                                  </li>
                                  <li>
                                    <p>Lack of role clarity.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Bullying and workplace violence and
                                      aggression.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center h-100 py-5">
                                  <li>
                                    <p>
                                      Ensure more workers are adequately trained
                                      so they can assist customers and deal with
                                      problems.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Ensure adequate number of experienced
                                      workers are rostered during peak periods.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Arrange, where possible, for supplies to
                                      be delivered outside peak periods or for
                                      extra workers to be rostered during these
                                      times.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Reorganise and maintain the loading dock,
                                      storeroom and shop floor to improve safety
                                      and efficiency.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Release the rosters well ahead of time so
                                      workers can plan better.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Ensures new workers have a thorough
                                      induction.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Provide training to all workers.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Put up signs displaying designated queuing
                                      areas, and warnings that abuse of workers
                                      will result in refusal of service, etc.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Ensure all hazardous manual handling/task
                                      risks are effectively identified, assessed
                                      and control measures implemented.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Update the policy and procedures, as
                                      required, to address identified gaps.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="row ps-4  ps-md-0">
                            <div className="col-2 p-0">
                              <div className="environmental h-100">
                                <strong className="br-top d-flex align-items-center flex-column justify-content-center py-5 gap-3 h-100">
                                  Manufacturing
                                </strong>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center py-5 h-100">
                                  <li>
                                    <p>Role underload.</p>
                                  </li>
                                  <li>
                                    <p>Low job control.</p>
                                  </li>
                                  <li>
                                    <p>Lack of task variety.</p>
                                  </li>
                                  <li>
                                    <p>Low job control.</p>
                                  </li>
                                  <li>
                                    <p>Lack of role clarity.</p>
                                  </li>
                                  <li>
                                    <p>Poor change management consultation.</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center h-100 py-5">
                                  <li>
                                    <p>
                                      Arrange for workers to rotate every few
                                      hours to a new task in the plant allowing
                                      more opportunities to learn new skills,
                                      reduce boredom and fatigue and allow more
                                      flexibility to take toilet breaks.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Ensure work is allocated equitably amongst
                                      the workforce to avoid both overload and
                                      underload.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Ensure all workers have had training on
                                      any new software.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="row ps-4  ps-md-0">
                            <div className="col-2 p-0">
                              <div className="environmental h-100">
                                <strong className="br-top d-flex align-items-center flex-column justify-content-center py-5 gap-3 h-100">
                                  Small transport business
                                </strong>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center py-5 h-100">
                                  <li>
                                    <p>Role overload.</p>
                                  </li>
                                  <li>
                                    <p>Low job control.</p>
                                  </li>
                                  <li>
                                    <p>Poor support from managers.</p>
                                  </li>
                                  <li>
                                    <p> Workplace violence and aggression.</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-5 p-0">
                              <div className="environmental h-100">
                                <ul className="d-flex flex-column gap-3 justify-content-center h-100 py-5">
                                  <li>
                                    <p>
                                      Manage customer expectations by
                                      incorporating revised delivery timeframes
                                      into their customer online and phone
                                      ordering processes.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Contract additional drivers and
                                      distributing interstate deliveries across
                                      all drivers to manage risk of fatigue.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Provide drivers with training in
                                      de-escalation techniques for dealing with
                                      aggressive customers.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Develop and implement fatigue management
                                      strategies and ensure all workers comply
                                      with requirements.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Notify customers of company policy on
                                      delivery timeframes and that verbal
                                      aggression is not acceptable.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Check in with drivers before agreeing to
                                      delivery schedules to ensure these are
                                      realistic and encourage early feedback on
                                      delivery issues.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Introduce a system to alert the dispatch
                                      manager and retail business if delivery
                                      delays are likely.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => Lesson_next("4")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson5 && (
            <section id="monitoring" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#hazards"
                  ref={lesson5_href}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 4 - Managing the Hazards</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 5 of 9</h4>
                      <h1>Monitoring and Evaluating Control Measures</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        To ensure the prevention or elimination of psychological
                        risks, it's crucial to regularly review control
                        measures, given that psychological harm may not be as
                        readily apparent as physical harm.
                      </p>
                      <p>Control measures should undergo review:</p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>Following a psychological injury occurrence.</p>
                        </li>
                        <li>
                          <p>Before implementing organizational changes.</p>
                        </li>
                        <li>
                          <p>
                            Upon receipt of new information indicating a control
                            measure's potential ineffectiveness.
                          </p>
                        </li>
                      </ul>
                      <p>
                        Frequent review of control measures allows for early
                        prevention of psychological injuries.
                      </p>
                      <p>
                        Effective management of psychological risks hinges on
                        continual and open communication within the workplace.
                        This entails consulting with our workers and fostering
                        an environment where information sharing is encouraged,
                        thereby reducing the likelihood of injuries.
                      </p>
                    </div>
                  </div>
                  <div className="d-block padding btn-block text-center">
                    <button type="button" onClick={() => Lesson_next("5")}>
                      CONTINUE
                    </button>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson6 && (
            <section id="quiz" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={lesson6_href}
                  to="#monitoring"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>
                    Lession 5 - Monitoring and Evaluating Control Measures
                  </h5>
                </Link>
                <div className="stop">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1 padding">
                    <div className="d-flex flex-column gap-3  py-5 lesson-block intro">
                      <h4>Lesson 6 of 9</h4>
                      <h1>Quiz</h1>
                      <div className="line"></div>
                    </div>
                    {quest_6 && (
                      <p>
                        Before we begin, let's assess your current
                        comprehension.
                      </p>
                    )}
                    {quest_6 && (
                      <div className="start-quiz d-flex py-4  align-items-center ">
                        <Link to="#">
                          Start Quiz<i className="far fa-angle-right px-2"></i>
                        </Link>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-10 offset-md-1 padding">
                    <div className="q1 introdu py-5 d-flex flex-column gap-3">
                      {quest_6 && (
                        <span>
                          Question
                          <br />
                          <strong>01/01</strong>
                        </span>
                      )}
                      {quest_6 && (
                        <p>
                          Who has the responsibility to ensure the psychological
                          health of workers?
                        </p>
                      )}
                      {quest_6 && (
                        <div className="d-flex py-5 flex-column gap-5 introdu">
                          <div
                            className={`d-flex gap-3 ${isOpacity_6_1 ? " opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Managers"
                                name="fav_language"
                                value="Managers"
                                checked={checkQ_6_1 === "Managers"}
                                onChange={() => startQuiz_6_1("Managers")}
                              />
                              {isfirstquiz_6_1 &&
                                (issetQuizAns_6_1_btn === "Managers" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check1">
                                    <i className="fas fa-times text-fail"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Managers">Managers</label>
                          </div>
                          <div
                            className={`d-flex gap-3 ${isOpacity_6_1 ? " opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Employers"
                                name="fav_language"
                                value="Employers"
                                checked={checkQ_6_1 === "Employers"}
                                onChange={() => startQuiz_6_1("Employers")}
                              />
                              {isfirstquiz_6_1 &&
                                (issetQuizAns_6_1_btn === "Employers" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check1">
                                    <i className="fas fa-times text-fail"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Employers">Employers</label>
                          </div>
                          <div
                            className={`d-flex gap-3 ${isOpacity_6_1 ? " opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Duty Holders"
                                name="fav_language"
                                value="Duty Holders"
                                checked={checkQ_6_1 === "Duty Holders"}
                                onChange={() => startQuiz_6_1("Duty Holders")}
                              />
                              {isfirstquiz_6_1 &&
                                (issetQuizAns_6_1_btn === "Duty Holders" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check1">
                                    <i className="fas fa-times text-fail"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Duty Holders">Duty Holders</label>
                          </div>
                          <div
                            className={`d-flex gap-3 ${isOpacity_6_1 ? " opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Workers"
                                name="fav_language"
                                value="Workers"
                                checked={checkQ_6_1 === "Workers"}
                                onChange={() => startQuiz_6_1("Workers")}
                              />
                              {isfirstquiz_6_1 &&
                                (issetQuizAns_6_1_btn === "Workers" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check1">
                                    <i className="fas fa-times text-fail"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Workers">Workers</label>
                          </div>
                          <div
                            className={`d-flex gap-3 ${isOpacity_6_1 ? " opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Everyone"
                                name="fav_language"
                                value="Everyone"
                                checked={checkQ_6_1 === "Everyone"}
                                onChange={() => startQuiz_6_1("Everyone")}
                              />
                              {isfirstquiz_6_1 &&
                                (issetQuizAns_6_1_btn === "Everyone" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check1">
                                    <i className="fas fa-times text-fail"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Everyone">Everyone</label>
                          </div>
                          {worngansQuiz_6_1 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-times"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>Sorry that's not correct.</p>
                              </div>
                            </div>
                          )}
                          {rightansQuiz_6_1 && (
                            <div className="d-flex justify-content-center">
                              <div className="text-center">
                                <Link to="javascript:void(0)" className="">
                                  <i class="fas fa-check"></i>
                                </Link>
                                <p>
                                  <strong>Thanks for confirmation</strong>
                                </p>
                                <p>That's correct - well done.</p>
                              </div>
                            </div>
                          )}
                          {q1_6_next && (
                            <div className="d-flex justify-content-center">
                              <button
                                type="button"
                                onClick={() => Quiz_next_6("1")}
                              >
                                Next
                              </button>
                            </div>
                          )}
                          {step6_btn && (
                            <div className="d-flex justify-content-center">
                              <button
                                type="button"
                                onClick={() => check6_btn()}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                      {step6_score && (
                        <div className="br-top">
                          <h5>Quiz Results</h5>
                          <div className="quiz-result d-flex justify-content-center  align-items-center py-4">
                            <div
                              className="pie position-relative "
                              data-pie='{ "cut": 30, "percent": 75, "rotation": 144, "colorSlice": "#F50057", "colorCircle": "#f1f1f1", "textPosition": "1em", "fontSize": "1.2rem" }'
                              data-pie-index="1"
                              style={{ width: "500px", height: "500px" }}
                            >
                              <div className="position-relative d-flex justify-content-center ">
                                <svg
                                  role="progressbar"
                                  width="500"
                                  height="500"
                                  viewBox="0 0 100 100"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                  aria-valuenow="56"
                                >
                                  <circle
                                    cx="50%"
                                    cy="50%"
                                    r="42"
                                    shape-rendering="geometricPrecision"
                                    fill="none"
                                    stroke="#f1f1f1"
                                    stroke-width="2"
                                    stroke-dashoffset="79.19999999999999"
                                    style={{
                                      transform: "rotate(144deg)",
                                      transformOrigin: "50% 50%",
                                    }}
                                    stroke-dasharray="264"
                                    stroke-linecap=""
                                  ></circle>
                                  <circle
                                    cx="50%"
                                    cy="50%"
                                    r="42"
                                    shape-rendering="geometricPrecision"
                                    className="pie-circle-1"
                                    fill="none"
                                    stroke-width="2"
                                    stroke-dashoffset="160.512"
                                    stroke-dasharray="264"
                                    stroke-linecap=""
                                    style={{
                                      transform: "rotate(144deg)",
                                      transformOrigin: "50% 50%",
                                      strokeDasharray: finalperc_6,
                                    }}
                                    stroke={stroke_6}
                                    data-angel="56"
                                  ></circle>
                                </svg>
                                <div className="pie-text-1">
                                  <p>Your score {score_6}%</p>
                                  {!corr_6 && <i className="fas fa-check"></i>}
                                  {corr_6 && <i className="fas fa-times"></i>}
                                </div>
                              </div>
                              <div className="percentage">
                                <p>Passing</p>
                                <p>80%</p>
                              </div>
                              <div className="refresh">
                                <i
                                  className="fas fa-redo"
                                  onClick={refresh_6}
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {step6_score && (
                    <div className="d-flex flex-column">
                      <Link
                        to="#quiz"
                        onClick={() => Lesson_next("6")}
                        className="backpage text-center d-flex flex-column"
                      >
                        <i className="far fa-angle-down"></i>
                        <h5>
                          Lesson 7 - Responding To A Report Of A Psychosocial
                          Risk Or Incident
                        </h5>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </section>
          )}
          {lesson7 && (
            <section id="incident" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#quiz"
                  onClick={() => backlesson("6")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 6-Quiz</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 7 of 9</h4>
                      <h1>
                        Addressing a Report of a Psychosocial Risk or Incident
                      </h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <h5>Reporting a Risk or Incident</h5>
                      <p>
                        The Organization is dedicated to fostering a positive
                        and respectful workplace culture that actively
                        encourages early reporting and follow-up, ensuring that
                        psychosocial hazards and risks are addressed before
                        significant harm occurs.
                      </p>
                      <p>
                        In pursuit of this goal, we will establish and
                        communicate various channels for you to report workplace
                        incidents, both informally and formally, and in a
                        confidential manner. These may include:
                      </p>

                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            Engaging in discussions during meetings involving
                            organizations with shared responsibilities.
                          </p>
                        </li>
                        <li>
                          <p>
                            {" "}
                            Participating in conversations with coworkers,
                            supervisors, and managers.
                          </p>
                        </li>
                        <li>
                          <p> Completing hazard or incident reports.</p>
                        </li>
                        <li>
                          <p>
                            {" "}
                            Utilizing mediums such as emails, mobile text
                            messages, or letters to communicate complaints or
                            grievances.
                          </p>
                        </li>
                        <li>
                          <p>
                            {" "}
                            Accessing information related to workers'
                            compensation claims.
                          </p>
                        </li>
                        <li>
                          <p>
                            {" "}
                            Reviewing reports submitted by health and safety
                            representatives.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="d-block px-5">
                    <img
                      className="w-100 px-5"
                      src={require("../assets/ohs/images/boss.jpg")}
                      alt="img"
                    />
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-5 introdu"
                    >
                      <h5>Conducting an Incident Investigation</h5>
                      <p>
                        In response to a report of a significant workplace
                        psychosocial incident, the Organization will initiate an
                        investigation in a fair, timely, and equitable manner.
                        The investigation aims to uncover the details of the
                        incident, understand its underlying causes, and identify
                        measures to enhance controls, thereby preventing
                        recurrence of similar incidents in the future.
                      </p>
                      <h5>Notifiable Incident</h5>
                      <p>
                        In the event of a notifiable workplace incident, such as
                        a fatality or a severe physical or psychological injury
                        or illness necessitating immediate hospitalization, we
                        will promptly inform the health and safety regulator
                        once we become aware of the incident. Each incident will
                        be documented, and a record will be securely maintained
                        to uphold privacy and confidentiality.
                      </p>
                    </div>
                    <div className="d-block padding  btn-block text-center">
                      <button type="button" onClick={() => Lesson_next("7")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson8 && (
            <section id="supporting" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#incident"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>
                    Lesson 7 - Addressing a Report of a Psychosocial Risk or
                    Incident
                  </h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 8 of 9</h4>
                      <h1>Supporting Recovery</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>Supporting Injured Workers' Recovery</p>
                      <p>
                        We are committed to fulfilling our obligations under
                        workers' compensation laws to aid in the recovery of
                        injured workers. This involves:
                      </p>

                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            Offering early assistance and facilitating access to
                            treatment and rehabilitation services, typically
                            from the moment a claim is filed.
                          </p>
                        </li>
                        <li>
                          <p>
                            {" "}
                            Supporting a prompt and sustainable return to work
                            through productive consultation and addressing any
                            lingering work-related psychosocial hazards or risks
                            that could worsen existing injuries or lead to new
                            ones.
                          </p>
                        </li>
                        <li>
                          <p>
                            {" "}
                            Regularly reviewing the efficacy of control measures
                            to prevent further harm or the occurrence of new
                            injuries.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="d-block px-5">
                    <img
                      className="w-100 px-5"
                      src={require("../assets/ohs/images/worker-men.jpg")}
                      alt="img"
                    />
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-5 introdu"
                    >
                      <div className="d-block  btn-block text-center">
                        <button type="button" onClick={() => Lesson_next("8")}>
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson9 && (
            <section id="assessment" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#respond"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 9 How To Respond To An Emergency</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 9 of 9</h4>
                      <h1>Final Assessment</h1>
                      <div className="line" style={{ width: "100%" }}></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <form action="javascript:void(0)">
                    <div className="col-lg-10 offset-md-1 padding py-5">
                      {sec_1 && (
                        <div className="d-flex flex-column gap-5 fullname-block text-center py-5">
                          <h4>
                            Please enter your FULL NAME before you continue:
                          </h4>
                          <div className="d-flex justify-content-center name-form">
                            <div className="d-flex gap-2">
                              <div className="flex-grow-1">
                                <input
                                  type="text"
                                  name=""
                                  id=""
                                  required
                                  onInput={entername_9}
                                  ref={inputRef}
                                  placeholder="Type your name here..."
                                />
                              </div>
                              <div className="flex-shrink-0">
                                <button type="submit" onClick={btn_entername}>
                                  Continue
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {quizless_9_1 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            Officers of an organisation do not have any health
                            and safety responsibilities:
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="True"
                                  checked={checkQ_9_1 === "True"}
                                  onChange={() => startQuiz_9_1("True")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "True" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="True">
                                True
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="False"
                                  checked={checkQ_9_1 === "False"}
                                  onChange={() => startQuiz_9_1("False")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "False" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="False">
                                False
                              </label>
                            </div>

                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q1_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("1")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_1_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("1")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_2 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            Which of the below are health and safety
                            responsibilities an organisation may be required to
                            perform?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check  ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="All"
                                  checked={checkQ_9_2 === "All"}
                                  onChange={() => startQuiz_9_2("All")}
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn === "All" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="All">
                                Provide all necessary PPE
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="CD"
                                  checked={checkQ_9_2 === "CD"}
                                  onChange={() => startQuiz_9_2("CD")}
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn === "CD" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="CD">
                                CD Provide appropriate health and safety
                                training for workers
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Provide"
                                  checked={checkQ_9_2 === "Provide"}
                                  onChange={() => startQuiz_9_2("Provide")}
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn === "Provide" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Provide">
                                Provide welfare facilities
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Complete"
                                  checked={checkQ_9_2 === "Complete"}
                                  onChange={() => startQuiz_9_2("Complete")}
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn === "Complete" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Complete"
                              >
                                Complete accident and incident investigations
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q2_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("2")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_2_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("2")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_3 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            An organisation must consult with workers on health
                            and safety matters, which of the below are topics
                            that must be discussed?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Any"
                                  checked={checkQ_9_3 === "Any"}
                                  onChange={() => startQuiz_9_3("Any")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "Any" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Any">
                                Any new workplace hazards
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="New work"
                                  checked={checkQ_9_3 === "New work"}
                                  onChange={() => startQuiz_9_3("New work")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "New work" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="New work"
                              >
                                New work practices and new work equipment
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="New risk"
                                  checked={checkQ_9_3 === "New risk"}
                                  onChange={() => startQuiz_9_3("New risk")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "New risk" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="New risk"
                              >
                                New risk assessments or Cha nges to existing
                                risk assessments
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="All of"
                                  checked={checkQ_9_3 === "All of"}
                                  onChange={() => startQuiz_9_3("All of")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "All of" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="All of">
                                All of the above
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q3_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("3")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_3_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("3")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_4 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            The relevant health and safety regulators can impose
                            penalties to organisations and individual persons
                            who fail to comply with health and safety
                            legislation:?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="True"
                                  checked={checkQ_9_4 === "True"}
                                  onChange={() => startQuiz_9_4("True")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "True" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="True">
                                True
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="False"
                                  checked={checkQ_9_4 === "False"}
                                  onChange={() => startQuiz_9_4("False")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "False" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="False">
                                False
                              </label>
                            </div>

                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q4_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("4")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_4_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("4")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_5 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            Workers are provided PPE to be worn while performing
                            a specific task. What are the responsibilities of a
                            worker when they are provided PPE?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Workers"
                                  checked={checkQ_9_5 === "Workers"}
                                  onChange={() => startQuiz_9_5("Workers")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "Workers" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Workers">
                                Workers must wear their PPE whilst performing
                                the task
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Nothing"
                                  checked={checkQ_9_5 === "Nothing"}
                                  onChange={() => startQuiz_9_5("Nothing")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "Nothing" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Nothing">
                                Nothing — they are not responsible for their own
                                health and safety
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Ensure"
                                  checked={checkQ_9_5 === "Ensure"}
                                  onChange={() => startQuiz_9_5("Ensure")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "Ensure" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Public_Health"
                              >
                                Ensure they are tra ined to safely use the PPE
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Ensure they"
                                  checked={checkQ_9_5 === "Ensure they"}
                                  onChange={() => startQuiz_9_5("Ensure they")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "Ensure they" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Ensure they"
                              >
                                Ensure they are trained on how to properly
                                maintain and dispose of the PPE
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q5_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("5")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_5_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("5")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {less_5_finresult && (
                        <div className="d-flex flex-column gap-3 text-center results-block">
                          <h3 className="text-danger">Results</h3>

                          <div className="row gy-3 gy-md-5">
                            <div className="col-lg-9">
                              <h3>
                                <b>Your Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-9">
                              <h3>
                                {score__per5}% ({score_5} points)
                              </h3>
                            </div>
                            <div className="col-lg-9">
                              <h3>
                                <b>Passing Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-9">
                              <h3>80% (40 points)</h3>
                            </div>
                            <div className="col-12">
                              {!corrScore && (
                                <h4 className="text-danger">
                                  <i className="far fa-times"></i> You did not
                                  pass
                                </h4>
                              )}
                              {corrScore && (
                                <h4 className="text-success">
                                  <i className="far fa-check check"></i> You
                                  pass
                                </h4>
                              )}
                            </div>
                            {!corrScore ? (
                              <div className="col-lg-">
                                <button type="button" onClick={refreshbtn}>
                                  Retry Assessment
                                </button>
                              </div>
                            ) : (
                              <div className="col-lg-">
                                <button type="button" onClick={downloadpdf}>
                                  Download
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </>
  );
};
